// 动态获取当前域名和协议，避免跨域问题
const getCurrentBaseUrl = () => {
  const { protocol, hostname } = window.location;
  if (hostname === 'w.zghsgmsy.com') {
    return `${protocol}//www.zghsgm.com/`;
  }
  
  if (hostname === 'www.zghsgm.com') {
    return 'https://www.zghsgm.com/';
  }
  
  // 本地开发环境
  if (hostname === 'localhost' || hostname === '127.0.0.1'||hostname === '192.168.1.95') {
    // return 'https://w.zghsgm.com/';
    // return 'http://localhost:8081/';
    // return 'http://192.168.1.95:8081/';
    return '/';
  }
  
  // 默认使用当前协议和域名
  return `${protocol}//${hostname}/`;
};

export default {
  baseUrl: getCurrentBaseUrl(),
  baseUrl2: 'https://video.hongsejiankang.cn/',
  filePreview:'https://www.zghsgm.com/',
  // baseUrl: 'http://192.168.10.164/index.php/v1',
  // filePreview:'http://192.168.10.164/static/uploads/'
}
